import React from "react";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styles from '@/styles'
import styled from "styled-components";
import { jumpTo } from "../../utils";


export const isStorm = bwmodel.app === 'storm';
const Rule = () => {
  
  return <div>

  {isStorm && 
    <Header
      title="活动规则"
      hideNaviBar
      bg_color={styles.bg_color2}
      right={
        <div 
          onClick={()=> {
            jumpTo('https://m.wogoo.com/serviceCode');
          }}
          className="title_right"
        >
          
        {bwmodel.theme === '0' ?      <img src={require('./images/kefu2.png')} alt='' />:   <img src={require('./images/kefu.png')} alt='' />} 
              {/* <img src={require('./images/kefu2.png')} alt='' /> */}
          联系客服
          </div>
      }
    />
  }
  <Container>
  <h2>一、开始时间：</h2>
  <p>2024.12.10</p>

  <h2>二、活动人群：</h2>
  <p>所有用户均可参与；</p>
  


{/* <image image.png */}
{/* <img src={require('./images/image.png')} alt='' className="explain-img" />
六、对于以任何不正当方式参与活动的用户。
包括但不限干侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得，保留将各种奖励扣回的权利，并对账号进行永久限制。

七、本活动最终解释权归市值风云所有。 */}


<h2>三、活动大礼包</h2>
<p>礼包1：优惠大礼包</p>
<p>1200元优惠券*1、3001元优惠券*1、200元优惠券*1、1200元优惠券*6；</p>

<p>礼包2：加赠大礼包</p>
 <p>在活动页面买年卡即赠送3个月会员时长</p>
 <p>礼包3</p>
 <p>涨停大礼包：股市好运18籽串、常山专属日历、股市专属涨停符</p>
 <h2>四：如何获得大礼包</h2>
 <p>在活动期间在活动页面购买指定的会员年卡即可获得相应大礼包奖励：</p>
  <p>1、购买风云VIP年卡 可获得：</p>
  <p>风云VIP年卡、风云VIP3个月时长（93天）奖励、涨停大礼包（股市好运18籽串、常山专属日历、股市专属涨停符）</p>
  <p>2、购买其他会员年卡（风云VIP年卡、研报畅读年卡、短线挖掘年卡、吾股排名年卡、吾股复盘年卡、红绿波段年卡、趋势拐点年卡、跳空异动年卡、一阳指年卡）可获得：</p>
  <p>会员年卡、会员3个月时长（93天）奖励</p>
  <h2>五、活动奖励兑现方式：</h2>
  <p>1、会员时长奖励和风云周边奖励均需用户在活动期间购买任意会员年卡才可获得，其中会员年卡包含：风云VIP年卡/研报畅读年卡/吾股排名年卡/短线掘金年卡。</p>
  <p>2、会员时长奖励发放：用户每次抽奖所获得的会员奖励天数将实时累加，且奖励天数实时展示在页面底部奖品中（用红色字体标注）。</p>
  <p>3、发放时间：</p>
  <p>所有奖励均会在活动结束后15个工作日内发放完成；</p>
  <p>会员时长奖励将在活动结束后自动结算，并充值进获奖用户的风云账户；</p>
  <p>涨停大礼包奖励：在活动期间的活动页面内购买风云VIP年卡的用户才能获得涨停大礼包奖励，同时需要在活动底部“填写收货信息”处按要求填写收货信息（如下图所示），我们将在活动结束后会统一通过快递形式发送给符合要求的用户。</p>
  <p>温馨提示：购买了风云VIP但未及时按要求填写的用户，我们视作默认不要礼物哦；</p>
    <img src={require('./images/image.png')} alt='' className="explain-img" />
  <h2>六、对于以任何不正当方式参与活动的用户。</h2>
  <p>包括但不限干侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得，保留将各种奖励扣回的权利，并对账号进行永久限制。</p>
  
  <h2>七、本活动最终解释权归市值风云所有。</h2>

  



</Container>
</div>
}

export default Rule;

const Container = styled.div`
  padding:44px 10px;
  img {
    width: 100%;
  }
  p {
    line-height: 1.5;
  }
`


// WEBPACK FOOTER //
// ./src/views/activity_139/rules.js